import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  sample_json: '',
  placeholders: [],
  jsonPlaceholder: '',
  samplePlaceholders: [],
});

const { getStore: getParseJSONStore, defaultStore } = createComponentStore({
  type: 'parse_json',
  endpoint: 'parse_json',
  registryKey: 'parse_json',
  initData,

  extraState: () => ({
    placeholderError: null,
  }),

  extraActions: (set, get) => ({
    storeError: (obj) => set({ placeholderError: obj }),

    setPlaceholders: (placeholders) => {
      set({ data: { ...get().data, placeholders } });
    },

    setJSONPlaceholder: (placeholder) => {
      set({ data: { ...get().data, jsonPlaceholder: placeholder } });
    },

    setSampleJSON: (sampleJson) => {
      set({ data: { ...get().data, sample_json: sampleJson } });
    },

    deletePlaceholders: () => {
      set({ data: { ...get().data, placeholders: [] } });
    },

    clearField: () => {
      set({ data: { ...get().data, samplePlaceholders: [] } });
    },

    addJsonData: (obj) => {
      set({ data: { ...get().data, samplePlaceholders: [...get().data.samplePlaceholders, obj] } });
    },

    jsonData: (key, value) => ({
      key: key,
      sampleKey: key,
      sampleData: value,
      checked: true,
    }),

    onChangeField: (value, placeholder, type) => {
      set((s) => {
        const samplePlaceholders = s.data.samplePlaceholders.map((p) => ({ ...p }));
        const index = samplePlaceholders.findIndex((x) => x.key === placeholder.key);
        if (index === -1) return {};
        switch (type) {
          case 'content':
            samplePlaceholders[index].sampleKey = value;
            samplePlaceholders[index].sampleData = '';
            break;
          case 'json':
            return { data: { ...s.data, json: value } };
          case 'key':
            samplePlaceholders[index].key = value;
            break;
          case 'timeout':
            return { data: { ...s.data, timeout: value } };
          default:
            break;
        }
        return { data: { ...s.data, samplePlaceholders } };
      });
    },

    // Backward-compat aliases
    setParseJSONTemplate: (component) => get().setComponentData(component),
    setParseJSONName: (name) => set({ name }),
  }),
});

export { getParseJSONStore };
export default defaultStore;
